import { motion } from "framer-motion";
import { EASE } from "../../lib/site";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, light = false }) => (
  <div className={`flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] ${light ? "text-[#E7C27D]" : "text-terra"}`}>
    <span className={`h-px w-10 ${light ? "bg-[#E7C27D]" : "bg-terra"}`} />
    {children}
  </div>
);

export const ClipImage = ({ src, alt, className = "", imgClass = "", testid }) => (
  <motion.div initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.15 }} className={className} data-testid={testid}>
    <motion.div
      className="relative h-full w-full overflow-hidden"
      variants={{ hidden: { clipPath: "inset(12% 8% 12% 8%)" }, show: { clipPath: "inset(0% 0% 0% 0%)" } }}
      transition={{ duration: 1.3, ease: EASE }}
    >
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        className={`h-full w-full object-cover ${imgClass}`}
        variants={{ hidden: { scale: 1.25 }, show: { scale: 1 } }}
        transition={{ duration: 1.6, ease: EASE }}
      />
    </motion.div>
  </motion.div>
);
